import request from '@/utils/request'

export function updateAbilityCfg(data) {
  return request({
    url: 'api/v1/ability/updateList',
    method: 'post',
    data: data
  })
}
export function delAbilityCfg(data) {
  return request({
    url: 'api/v1/ability/delCfg',
    method: 'delete',
    data: data
  })
}

export function getAbilityCfgList(data) {
  return request({
    url: 'api/v1/ability/getList',
    method: 'post',
    data: data
  })
}

export function exportAbilityCfg() {
  return request({
    url: 'api/v1/ability/export',
    method: 'get' })
}

export function importAbilityCfg(data) {
  return request({
    url: 'api/v1/ability/import',
    method: 'post',
    data: data
  })
}
export function getAbilityCapType() {
  return request({
    url: 'api/v1/ability/getCapType',
    method: 'get'
  })
}

